import '@/assets/css/tailwind.css';

import Vue from 'vue';
import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);

import App from './App.vue';
import Home from './components/Home.vue';

window.axios = require('axios');

window.constants = {};
window.constants["getCities"] = require('@/assets/js/cities.js').getCities;
window.constants["getWalls"] = require('@/assets/js/walls.js').getWalls;
window.constants["getSlabs"] = require('@/assets/js/slabs.js').getSlabs;
window.constants["getComposites"] = require('@/assets/js/composites.js').getComposites;
window.constants["getWindows"] = require('@/assets/js/windows.js').getWindows;
window.constants["getDoors"] = require('@/assets/js/doors.js').getDoors;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

Vue.config.productionTip = false;

const files = require.context('./', true, /\.vue$/i);
files
  .keys()
  .map((key) =>
    Vue.component(key.split('/').pop().split('.')[0], files(key).default)
  );

new Vue({
  render: (h) => h(App),
  components: {
    home: Home,
  },
}).$mount('#app');
